module.exports = __webpack_public_path__ + "img/teambox-image@2x.eb61f655.png";